import {Component, OnInit} from '@angular/core';
import {AuthUntilUserRoleService} from '../../core/authentication/auth-until-user-role.service';
import {ErrorNotificationService} from '../../core/error-notification.service';
import {BotatoChatManagerService} from 'botato-angular-lib';
import {filter} from 'rxjs';
import {NavigationEnd, Router} from '@angular/router';
import {BotIdService} from '../../../../../micromate-learn-lib/src/lib/services/BotIdService';

@Component({
    selector: 'mm-learning',
    templateUrl: './learning.component.html',
    styleUrls: ['./learning.component.scss'],
    standalone: false
})
export class LearningComponent implements OnInit {

    constructor(public authUntilUserRoleService: AuthUntilUserRoleService,
                public errorNotificationService: ErrorNotificationService,
                private chatManager: BotatoChatManagerService,
                private router: Router,
                public botIdService: BotIdService) {
    }

    public ngOnInit(): void {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            if (event.urlAfterRedirects === '/learn') {
                this.chatManager.scrollToBottom(false);
            }
        });
    }
}
